module.exports = __webpack_public_path__ + "static/media/svgicons8-children.3cc8342e.svg";